import React from "react";
import styled from "styled-components";
import StickyHeaderLayout from "components/Layout/StickyHeaderLayout";
import { Footer } from "@literati/public-ui-shared-react";

import { LinkNext, Theme, colors } from "@literati/public-ui-shared-react";
import { ExtraCreditBookSearchSvg } from "components/extraCredit/ExtraCreditBookSearchSvg";
import { LINKS } from "globalConfig";

export const DEFAULT_ERROR_MESSAGE = "Hmm, we checked our glossary...";

interface GenericErrorProps {
  className?: string;
  label?: string;
}

/** This is the className that will be pre-pended to all of ExtraCreditSectionInvalidIdError's inner component classNames */
export const GENERIC_ERROR_CLASS_BASE = "generic-error-page";

/** These are all of the internal classNames that are used within the ExtraCreditSectionInvalidIdError component */
export const GenericErrorClassName = {
  BASE: GENERIC_ERROR_CLASS_BASE,
} as const;

const StyledSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  gap: 2rem;
  width: calc(100% - 2rem);
  max-width: 660px;
  color: ${colors.black};
`;

const HeadingText = styled.h1`
  font-size: 2rem;
  text-align: center;
`;

const BodyText = styled.p`
  color: ${colors.black};
  text-align: center;
  font-size: 1.25rem;
`;

const Layout = styled(StickyHeaderLayout)`
  padding-top: 3.5em;
  min-height: auto;
  background: none;
`;
export const GenericError = ({ className = "", label }: GenericErrorProps) => {
  const subheader = label || DEFAULT_ERROR_MESSAGE;
  return (
    <Theme>
      <StyledSection className={`${GenericErrorClassName.BASE} ${className}`}>
        <ExtraCreditBookSearchSvg />
        <HeadingText>{subheader}</HeadingText>
        <BodyText>
          The page you are looking for cannot be accessed at this time. If
          you&apos;re interested in joining Literati,
          <LinkNext href={LINKS.subscribe} legacyBehavior={false}>
            {" "}
            click here.{" "}
          </LinkNext>
          Otherwise,{" "}
          <LinkNext href={LINKS.contact} legacyBehavior={false}>
            get in touch{" "}
          </LinkNext>
          so we can direct you to the right location.
        </BodyText>
      </StyledSection>
    </Theme>
  );
};
export const GenericErrorPage = (props: GenericErrorProps) => {
  const title = props?.label || DEFAULT_ERROR_MESSAGE;
  return (
    <>
      <Layout pageTitle={title}>
        <GenericError {...props} />
      </Layout>
      <Footer eventSource="literati-next-kids" />
    </>
  );
};
export default GenericErrorPage;
